import axios from 'axios'
import HTTP from './http'

export default {
    hmoCostPerAges: () => axios.get(HTTP.HMO_COST),
    updatePolicy: payload => axios.put(HTTP.HMO_COST, { payload }),
    setNewAges: payload => axios.patch(HTTP.HMO_COST, { payload }),
    getHmoComp: payload => axios.post(HTTP.HMO_COST, { payload })
}
